export default "__VITE_ASSET__DNlk4wFJ__"